/**
 * Related products (task E6).
 *
 * Deferred twice over: the script itself is defer, and the fetch does not fire
 * until the section is near the viewport. Recommendations are never worth
 * competing with the product's own images for bandwidth.
 */
(function () {
  'use strict';

  var V = window.Velocity;
  if (!V) return;

  class RelatedProducts extends V.Element {
    init() {
      if (!('IntersectionObserver' in window)) {
        this.load();
        return;
      }

      var self = this;
      this.observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          self.observer.disconnect();
          self.load();
        });
      }, { rootMargin: '400px 0px' });   // start just before it is needed

      this.observer.observe(this);
    }

    destroy() {
      if (this.observer) this.observer.disconnect();
    }

    load() {
      var self = this;
      var url = this.dataset.url +
        '?product_id=' + this.dataset.productId +
        '&limit=' + this.dataset.limit +
        '&section_id=' + this.dataset.sectionId;

      fetch(url)
        .then(function (res) {
          if (!res.ok) throw new Error('Recommendations failed: ' + res.status);
          return res.text();
        })
        .then(function (html) {
          var fragment = document.createRange().createContextualFragment(html);
          var content = fragment.querySelector('.related');

          // Empty result: remove the section rather than leave a bare heading.
          if (!content || !content.querySelector('.related__item')) {
            self.remove();
            return;
          }

          self.replaceWith(content);
          // Newly injected cards need their reveal and hover-swap wiring.
          if (V.motion) V.motion.refresh(content);
        })
        .catch(function () {
          self.remove();
        });
    }
  }

  V.define('related-products', RelatedProducts);
})();
